<template>
  <div>
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-card>
      <v-alert
        color="purple darken-2"
        type="warning"
        icon="mdi-hand-back-left"
        prominent
        text
        class="rounded-bl-0 rounded-br-0"
      >
        <h5>{{ $t('forms.info.vinculationForm.title') }}</h5>
        <div v-html="$t('forms.info.vinculationForm.message')"></div>
        <v-divider
          class="my-4 info"
          style="opacity: 0.22"
        ></v-divider>
        <v-row>
          <v-col
            class="text-center"
            justify="space-around"
          >
            <v-btn
              color="purple darken-4"
              outlined
              v-if="processData.object_id"
              :to="`/researchers/${processData.object_id}/forms/modifyVinculationForm`"
            >
              {{ $t('forms.info.vinculationForm.button') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <v-form class="pa-6" ref="form">
        <v-row>
          <v-col cols="12" md="6">
            <v-combobox
              v-model="categorySelected"
              :items="categories"
              item-text="internal_name"
              :label="$t('label.category')"
              return-object
              outlined
              :readonly="disabledForm"
              :rules="rules.fieldRequired"
            ></v-combobox>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="investigator.vinculation.type"
              :items="vinculationTypes"
              item-value="value"
              item-text="text"
              :label="$t('type')"
              outlined
              :readonly="disabledForm"
              :rules="rules.fieldRequired"
            ></v-select
          ></v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-menu
              v-model="menu_start_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="investigator.vinculation.start_date"
                  :label="$t('label.startDate')"
                  prepend-inner-icon="event"
                  readonly
                  hide-details
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="investigator.vinculation.start_date"
                @input="menu_start_date = false"
                :readonly="disabledForm"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="menu_end_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="investigator.vinculation.end_date"
                  :label="$t('label.endDate')"
                  prepend-inner-icon="event"
                  readonly
                  hide-details
                  outlined
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="investigator.vinculation.end_date"
                :min="investigator.vinculation.start_date"
                @input="menu_end_date = false"
                :readonly="disabledForm"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-checkbox
                :label="$t('form.add.expiration_date')"
                v-model="extend_expiration_date"
                :readonly="disabledForm"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-checkbox
                :label="$t('form.add.workplace_date')"
                v-model="extend_workplace_assignation_date"
                :readonly="disabledForm"
            />
          </v-col>
        </v-row>
        <v-divider />
        <UserFormActions
          form_name_text="Vinculation"
          :form_name="form_name"
          :refForm="$refs.form"
          :object_type="object_type"
          :data="processData"
          :state="state"
          @change-state="changeState"
        />
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import investigatorData from "../../../mixins/investigator_data";
import investigator_model from "../../../mixins/model_utils/investigator_model";

export default {
  mixins: [changeState, validationRules, investigatorData, investigator_model],
  components: { RejectCommentLayout, UserFormActions },

  data: () => ({
    menu_start_date: false,
    menu_end_date: false,
    object_type: "investigator",
    form_name: "vinculationForm",
    state: "",
    reject_comment: "",
    categorySelected: "",
    show_link: false,
    extend_workplace_assignation_date: true,
    extend_expiration_date: true
  }),

  created() {
    this.loadDefaultDatesVinculation();
    this.getVinculationTypes();
    this.getCategories();
    this.getData();
  },

  computed: {
    updateVinculationForm() {
      return this.$route.meta.updateForm;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },
    processData() {
      let category = "";
      if (
        this.categorySelected !== null &&
        this.categorySelected !== undefined
      ) {
        if (typeof this.categorySelected == "string") {
          category = {
            id: null,
            internal_name: this.categorySelected
          };
        } else if (this.categorySelected.id != null) {
          category = this.categorySelected.id;
        } else {
          category = this.categorySelected;
        }
      } else {
        category = null;
      }
      return {
        title: this.investigator.name,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.investigator.id,
        data: {
          user: {
            vinculation: {
              person: this.investigator.id,
              start_date: this.investigator.vinculation.start_date,
              end_date: this.investigator.vinculation.end_date,
              category: category,
              type: this.investigator.vinculation.type
            },
            extend_expiration_date: this.extend_expiration_date,
            extend_workplace_assignation_date: this.extend_workplace_assignation_date
          }
        }
      };
    }
  },

  watch: {
    categories() {
      this.loadCategorySelected(this.investigator.vinculation.category)
    }
  },

  methods: {
    getData() {
      let path = "";
      if (this.updateVinculationForm || this.$route.meta.readOnly) {
        path =
          this.$store.state.endpoint +
          "/user/moderatedOperations/investigator/" +
          this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.investigator.vinculation = response.data.data.user.vinculation;
            this.extend_expiration_date = response.data.data.user.extend_expiration_date;
            this.extend_workplace_assignation_date = response.data.data.user.extend_workplace_assignation_date;
            this.state = response.data.state;
            this.reject_comment = response.data.reject_comment;
            this.investigator.id = response.data.object_id;
            this.getInvestigatorName(
              this.$store.state.endpoint + "/person/" + this.investigator.id
            );
            this.loadCategorySelected(this.investigator.vinculation.category);
            this.getInvestigatorVinculations(this.investigator.id)
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.getInvestigatorVinculations(this.$route.params.id)
        this.getInvestigatorName(
          this.$store.state.endpoint + "/person/" + this.$route.params.id
        );
      }
    },

    loadCategorySelected(item) {
      if (typeof item == "number") {
        this.categorySelected = this.categories.filter(
          category => category.id === item
        )[0];
      } else {
        this.categorySelected = item;
      }
    },
    getInvestigatorVinculations(id) {
      let path = this.$store.state.endpoint + "/vinculation/person/" + id;
      axios
        .get(path)
        .then(response => {
          this.show_link = response.data.length > 0
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
